const canonicalizedPurpose = (purpose: TRANSLATION_PURPOSE): string => (
    `${purpose.charAt(0).toUpperCase()}${purpose.slice(1)}`
);

export default canonicalizedPurpose;
